import { DoorCameraResponse } from '@hakimo-ui/hakimo/types';
import useAuthenticatedRequest from '../shared/useAuthenticatedRequest';

export function useDoorCameraDetails(
  doorId: string | null,
  onData?: (response: DoorCameraResponse) => void
) {
  const url = `/v2/orm/door/${doorId}/camera`;
  const request = new Request(url);

  return useAuthenticatedRequest<DoorCameraResponse>(request, {
    queryKey: ['door-camera', doorId],
    responseModifier: async (response) => {
      const respJson = await response.json();
      return respJson.payload;
    },
    onSuccess: onData,
    staleTime: 1000 * 60 * 60 * 24 * 7,
    enabled: !!doorId,
  });
}

export default useDoorCameraDetails;
